// var productCardMarkup = `

// {{#products}}
// <div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk">
//   <div class="ProductItem" style="visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
//     <div class="ProductItem__Wrapper">
//       <a href="{{du}}" class="ProductItem__ImageWrapper">
//         <div class="AspectRatio" style="max-width: 1387px;  --aspect-ratio: 0.666826923076923">
//           <img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" src="{{iu}}" alt="{{dt}}">
//         </div>
//       </a>
//       <div class="ProductItem__Info ProductItem__Info--left">
//         <h2 class="ProductItem__Title Heading">
//           <a href="{{du}}">{{dt}}</a>
//         </h2>
//         <div class="ProductItem__PriceList Heading">
//           $<span class="ProductItem__Price Price Text--subdued">{{pr}}</span>
//         </div>
//       </div>
//       <div class="remove-wishlist">
//         <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="remove-from-wishlist Link Link--underline">
//           Remove from wishlist
//         </a>
//       </div>
//     </div>
//   </div>
// </div>
// {{/products}}
// `;

var productCardMarkup = `

{{#products}}
<div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk">
<div class="ProductItem " style="visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
<div class="ProductItem__Wrapper">
	<a href="{{du}}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
		<div class="AspectRatio AspectRatio--withFallback" style="max-width: 1387px; padding-bottom: 149.963950973%; --aspect-ratio: 0.666826923076923">
			<img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" src="{{ct}}">
			<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" src="{{iu}}">
		</div>
	</a>
	<div class="ProductItem__Info ProductItem__Info--left">
		<h2 class="ProductItem__Title Heading">
          	<a href="{{du}}">{{dt}}</a>
        </h2>
		<div class="ProductItem__PriceList  Heading">$<span class="ProductItem__Price Price Text--subdued">{{pr}}</span>
		</div>
	</div>
	<div class="remove-wishlist">
		<a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="remove-from-wishlist Link Link--underline">
			Remove from wishlist
		</a>
	</div>
</div>
</div>
</div>
  {{/products}}
`;



function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      var formattedWishlistedProducts = products.map(function(p){
        p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        return p;
      });
      
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      
      attachClickListeners();
      
      handleProductImages();
    },
    window._swat.EventTypes.addToWishList
  );
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "Moved to cart";
     window.location.reload();
     console.log("Successfully added product to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}


function onRemoveFromWishlistClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  e.target.innerHTML = "Removing..";
  window._swat.fetch(function(products) {
		var epi = variantId; /* get the selected variant id as a number */
		var empi = productId; /* get the selected product id as a number */
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				_swat.removeFromWishList(product, console.log);
				console.log(product);
				location.reload(); /* introduce a page reload to rerender. */
			}
		})
	})
}



function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");
  var removefromwishlist = document.getElementsByClassName("remove-from-wishlist");
  
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  for (var i = 0; i < removefromwishlist.length; i++) {
    removefromwishlist[i].addEventListener('click', onRemoveFromWishlistClick, false);
  }
}

function handleProductImages() {
    var wrappers = document.querySelectorAll(
      '.ProductItem__Wrapper .ProductItem__ImageWrapper'
    );

    wrappers.forEach(function (wrapper) {
      var img = wrapper.querySelector(
        '.ProductItem__Image.ProductItem__Image--alternate'
      );

      if (!img) return;

      var src = img.getAttribute('src');

      if (!src || !src.trim()) {
        wrapper.classList.add('active');
        wrapper.classList.remove('ProductItem__ImageWrapper--withAlternateImage');
      }
    });
}
// document.addEventListener('DOMContentLoaded', handleProductImages);



